import { createSlice } from "@reduxjs/toolkit";

const weatherSlice = createSlice({
  name: "weather",
  initialState: {
    data: null,
    isLoading: false,
    error: null,
    success: false,
  },
  reducers: {
    fetchWeatherStart(state) {
      state.isLoading = true;
      state.error = null;
    },
    fetchWeatherSuccess(state, action) {
      state.isLoading = false;
      state.data = action.payload;
      state.success = true;
    },
    fetchWeatherFailure(state, action) {
      state.isLoading = false;
      state.error = action.payload;
      state.success = false;
    },
  },
});

export const { fetchWeatherStart, fetchWeatherSuccess, fetchWeatherFailure } =
  weatherSlice.actions;
export default weatherSlice.reducer;
